require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./antennes-epfl-0-4.json") })
        }
      }, "path---antennes-epfl-0-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---antennes-epfl-0-4!./.cache/json/antennes-epfl-0-4.json
// module id = 327
// module chunks = 231608221292675